<template>
  <div>
    <div class="form-fields">
      <p>
        All Cook County Department of Environment and Sustainability Asbestos &amp; Demolition permits will be sent to permitees
        electronically via email. A valid email address must be supplied in order to receive information regarding the permit,
        including approved permits. All fees are non-refundable.
      </p>
      <div class="form-group">
        <span class="form-text">
          Enter the email address to which all communications regarding <i>this</i> permit should be addressed, and to which
          the permit document should be sent.
        </span>
      </div>

      <base-input v-model="form.contactEmail"
                  fieldName="Permit Contact Email"
                  :validation="val.form.contactEmail"
                  placeholder="Primary Email Address"
                  type="email"/>

      <base-input v-model="form.confirmEmail"
                  fieldName="Permit Contact Confirm Email"
                  :validation="val.form.confirmEmail"
                  placeholder="Confirm Email Address"
                  type="email"/>
    </div>

    <bottom-navigation link="site">Facility Information</bottom-navigation>
  </div>
</template>

<script>
import ExplodedFieldset from '~/components/ExplodedFieldset';
import BaseInput from '~/components/BaseInput';
import BottomNavigation from '~/components/BottomNavigation';

export default {
  name: 'ContactInformation',
  components: { ExplodedFieldset, BaseInput, BottomNavigation },
  props: ['form', 'val'],
  mounted() {
    this.$emit('update:title', 'Contact Information');
  },
};
</script>
